'use strict';
import isFunction from 'lodash/isFunction';
import isUndefined from 'lodash/isUndefined';
import * as T from 'prop-types';
import React, {Component} from 'react';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mapTo';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/takeUntil';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
import {ButtonState, isButtonState} from '../../../core-utilities/enums/ButtonState';
import {labelType, StatefulButtonView} from './StatefulButtonView';


export class StatefulButtonComponent extends Component {
  static propTypes = {
    className: T.string,
    buttonClassName: T.string,
    frontClassName: T.string,
    backClassName: T.string,
    startClassName: T.string,
    confirmClassName: T.string,
    workingClassName: T.string,
    workingIconClassName: T.string,
    successClassName: T.string,
    failureClassName: T.string,
    useConfirmation: T.bool,
    usePropState: T.bool,
    mode: isButtonState,
    disabled: T.bool,
    onClick: T.func.isRequired,
    bindParam: T.any,
    startLabel: labelType,
    confirmLabel: labelType,
    workingLabel: labelType,
    successLabel: labelType,
    errorLabel: labelType,
    confirmTimeout: T.number,
    timeout: T.number,
  };

  static defaultProps = {
    confirmTimeout: 2500,
    timeout: 750,
  };

  constructor(props) {
    super(props);
    this.state = {
      mode: ButtonState.START,
    };
    this.handleClick = this.handleClick.bind(this);
    this.setState = this.setState.bind(this);
  }

  handleClick(e) {
    e.stopPropagation();
    if (!isFunction(this.props.onClick)) {
      return;
    }
    if (this.props.useConfirmation) {
      this.handleConfirmClick(e);
    } else {
      this.handleNormalClick(e);
    }
  }

  handleNormalClick(e) {
    if (this.getMode() === ButtonState.START) {
      this.handleCallClick(e);
    }
  }

  handleConfirmClick(e) {
    if (this.getMode() === ButtonState.START) {
      this.setState({mode: ButtonState.CONFIRM});
      this.startConfirmation$.next({});
    } else {
      this.handleCallClick(e);
    }
  }

  handleCallClick(e) {
    if (!this.props.usePropState) {
      this.click$.next({});
    } else if (!isUndefined(this.props.bindParam)) {
      if (this.props.useConfirmation) {
        // signal to cancel the confirm timeout
        this.click$.next({});
      }
      this.props.onClick(e, this.props.bindParam);
    } else {
      this.props.onClick(e);
    }
  }

  componentDidMount() {
    if (!this.props.usePropState) {
      this.click$ = new Subject();

      this.stateSubscription = this.click$
        .switchMap(() =>
          Observable
            .merge(
              Observable.of({mode: ButtonState.WORKING}),
              Observable
                .fromPromise(!isUndefined(this.props.bindParam)
                  ? this.props.onClick(this.props.bindParam)
                  : this.props.onClick()
                )
                .mapTo({mode: ButtonState.SUCCESS})
                .catch(() => Observable.of({mode: ButtonState.ERROR}))
                .mergeMap(state =>
                  Observable
                    .merge(
                      Observable.of(state),
                      Observable.timer(this.props.timeout)
                        .mapTo({mode: ButtonState.START})
                    )
                )
            )
        )
        .subscribe(this.setState);
    }

    if (this.props.useConfirmation) {
      if (!this.click$) {
        this.click$ = new Subject();
      }

      this.startConfirmation$ = new Subject();

      this.stateSubscription = this.startConfirmation$
        .switchMap(() =>
          Observable
            .merge(
              Observable.of({mode: ButtonState.CONFIRM}),
              Observable.timer(this.props.confirmTimeout)
                .mapTo({mode: ButtonState.START})
                .takeUntil(this.click$)
            )
        )
        .subscribe(this.setState);
    }
  }

  componentWillUnmount() {
    this.stateSubscription && this.stateSubscription.unsubscribe();
  }

  render() {
    return (
      <StatefulButtonView
        className={this.props.className}
        buttonClassName={this.props.buttonClassName}
        frontClassName={this.props.frontClassName}
        backClassName={this.props.backClassName}
        confirmClassName={this.props.confirmClassName}
        startClassName={this.props.startClassName}
        workingClassName={this.props.workingClassName}
        workingIconClassName={this.props.workingIconClassName}
        successClassName={this.props.successClassName}
        failureClassName={this.props.failureClassName}
        useConfirmation={this.props.useConfirmation}
        disabled={this.props.disabled}
        mode={this.getMode()}
        startLabel={this.props.startLabel}
        confirmLabel={this.props.confirmLabel}
        successLabel={this.props.successLabel}
        errorLabel={this.props.errorLabel}
        workingLabel={this.props.workingLabel}
        onClick={this.handleClick}
      />
    );
  }

  getMode() {
    if (this.state.mode === ButtonState.CONFIRM) {
      return ButtonState.CONFIRM;
    } else {
      return this.props.usePropState ? this.props.mode : this.state.mode;
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/components/buttons/StatefulButton/StatefulButtonComponent.js